import { Badge } from "@/components/badge";

interface InfoRowSlotsProps {
  label: string;
  slots:
    | {
        activeRequests: number;
        graphic: number;
        max: number;
        video: number;
        website: number;
      }
    | undefined;
}

export function InfoRowSlots({ label, slots }: InfoRowSlotsProps) {
  return (
    <div className="flex justify-between items-start py-2">
      <span className="text-sm font-medium text-gray-500 min-w-0 flex-shrink-0 mr-4">
        {label}
      </span>
      <div className="flex flex-wrap justify-end">
        <Badge className="mr-1 mt-1" isRounded variant="brand">
          {slots?.activeRequests} / {slots?.max}
        </Badge>
        <Badge className="mr-1 mt-1" isRounded>
          Graphic {slots?.graphic}
        </Badge>
        <Badge className="mr-1 mt-1" isRounded>
          Video {slots?.video}
        </Badge>
        <Badge className="mr-1 mt-1" isRounded>
          Website {slots?.website}
        </Badge>
      </div>
    </div>
  );
}
